import classNames from "classnames";
import { invert } from "lodash";

import { Cabin } from "@mui/icons-material";
import { Box } from "@mui/material";

import { AIRLINE_IMG, AIRLINE_NAME_MAP } from "@/constants/airline";
import { CabinNameMap, CabinsColors, airlineBgColor } from "@/constants/config";
import { bankCardSmallImg } from "@/constants/image-map";
import { BANK_NAME_MAP } from "@/constants/programs";

export const renderAirlineLogo = (value: string, isDarkMode: boolean) => {
  return (
    <Box
      className="rounded-[3px] p-[2px] w-[26px] h-[26px]"
      sx={{
        backgroundColor: isDarkMode ? airlineBgColor : "transparent",
        fontSize: 0,
      }}
    >
      <img
        className="w-full h-full object-contain"
        src={AIRLINE_IMG[invert(AIRLINE_NAME_MAP)[value]]}
        alt=""
      />
    </Box>
  );
};

export const renderBanksLogo = (value: string, isDarkMode: boolean) => {
  const bankName = invert(BANK_NAME_MAP)[value];
  const bankFinalName = bankName || value;
  if (bankCardSmallImg[bankFinalName]) {
    return (
      <Box
        className="rounded-[3px] p-[0px] w-[26px] h-[26px]"
        sx={{
          backgroundColor: isDarkMode ? airlineBgColor : "transparent",
          fontSize: 0,
        }}
      >
        <img
          className="w-full h-full object-contain"
          src={bankCardSmallImg[bankFinalName]}
          alt=""
        />
      </Box>
    );
  }
  return null;
};

export const renderProgramsLogo = (value: string, isDarkMode: boolean) => {
  if (AIRLINE_IMG[value]) {
    return (
      <Box
        className="rounded-[3px] p-[2px] w-[26px] h-[26px]"
        sx={{
          backgroundColor: isDarkMode ? airlineBgColor : "transparent",
          fontSize: 0,
        }}
      >
        <img className="w-full h-full object-contain" src={AIRLINE_IMG[value]} alt="" />
      </Box>
    );
  }
  return null;
};

export const renderCabinsColor = (cabinType: string, text: string) => {
  return (
    <div className="flex items-center gap-[4px]">
      <span
        className={classNames("w-[8px] h-[8px] bg-[red] rounded-full")}
        style={{ backgroundColor: CabinsColors[CabinNameMap[cabinType]] }}
      />
      {text}
    </div>
  );
};
